export const settings = {
  pusher_key: '19b0a138a03729847561',
  stripe_key: 'pk_live_Yo1yoePBwG85QJKmeB2hUSMF',
  premium_price: 2995,
}
